// theme.js
export const lightTheme = {
    colors: {
      primary: '#007bff',
      secondary: '#6c757d',
      background: '#f8f9fa',
      text: '#212529',
    },
    font: {
      family: 'Arial, sans-serif',
      size: '16px',
    },
  };
  
  export const darkTheme = {
    colors: {
        primary: '#2196F3',
        secondary: '#90caf9',
        background: '#1a1a1a',
        text: '#ffffff',
        messageBgLight: '#263238',
        messageBorderLight: '#455a64',
        messageTextLight: '#eceff1',
        navBgColor: '#262626',
        buttonBgColor: '#2196F3',
        buttonTextColor: '#ffffff',
        buttonHoverBg: '#1976D2',
        tableBgColor: '#2a2a2a',
        tableTextColor: '#ffffff',
        surfaceColor: '#2a2a2a',
        borderColor: '#404040',
      },
      font: {
        family: 'Arial, sans-serif',
        size: '16px',
      },
  };